module.exports = __webpack_public_path__ + "static/img/img_main.e6072ae0.png";